export default __webpack_public_path__ + "static/media/881.9d75da7b.png";